export const getNotifications = ({ page, orderBy, direction }) => ({
    itemsPerPage: 10,
    page,
    ...(orderBy && direction && { [`order[${orderBy}]`]: direction }),
});

const paragraphStyle = 'font-size: 14px; margin: 0;';
const anchorStyle = 'color: #D3A424;';
const logoStyle = 'height: 100%';

function notificationContentTemplate(editorValue, isDistributor, distributorLogoURL, companyName) {
    const distributorReference = isDistributor
        ? `à vous rapprocher de votre conseiller en investissements financiers (${companyName}) ou`
        : '';
    const logoUrl = window.location.origin + '/static/media/logo_peqan_rvb.93cb803b.png';
    const logoElement = `<img src="${logoUrl}" height="80" style="${logoStyle}" alt="logo"/>`;
    const distributorLogo = `<img src="${distributorLogoURL}" height="80" style="${logoStyle}" alt="distributor-logo"/>`;
    const allLogo = distributorLogoURL !== '' ? logoElement + distributorLogo : logoElement;

    return (
        '<div style="font-family: Inter, sans-serif; font-size: 16px; padding: 1em 4em; background-color: #F4F4F4;"><div style="border-radius: 2px; padding: 2em; background-color: #fff;">' +
        '<style type="text/css">p {margin: 0}</style>' +
        `<div style="height: 80px; display:flex; justify-content:center">` +
        allLogo +
        '</div></br>' +
        editorValue +
        '</br></br>' +
        `<p style="${paragraphStyle}">Ceci est un message automatique, veuillez ne pas répondre directement à ce message.</p>` +
        `<p style="${paragraphStyle}">Pour toute information, nous vous invitons ${distributorReference} à nous contacter à <a href="mailto:contact@peqan.fr" style="${anchorStyle}">contact@peqan.fr</a>.</p>` +
        '</div></div>'
    );
}

export const sendNotification = ({
    receiver,
    subject,
    messageContent,
    distributorLogoURL,
    senderName,
    userIsDistributor,
}) => ({
    receivers: [+receiver],
    subject: subject,
    content: notificationContentTemplate(
        messageContent,
        userIsDistributor,
        distributorLogoURL,
        senderName
    ),
});

export const sendMassNotification = ({
    receivers,
    subject,
    messageContent,
    distributorLogoURL,
    senderName,
    userIsDistributor,
    documentId,
}) => ({
    receivers,
    subject,
    documentId: documentId || undefined,
    content: notificationContentTemplate(
        messageContent,
        userIsDistributor,
        distributorLogoURL,
        senderName
    ),
});

export const sendSMS = payload => ({
    userId: payload.receiver,
    message: payload.message,
});
